import {computed} from "vue";
import {useMedicationCheckupStore} from "@/medication-checkup/stores/medication-checkup-store";

/**
 * The way into the next step, once the one shown is over: the step the
 * course declares after it, named as the pinned definition names it.
 *
 * Closing a step leaves its record on screen rather than jumping ahead, so
 * moving on is the pharmacist's move — offered both by the checklist beside
 * the thread and at the end of the thread itself.
 */
export function useNextStep() {
    const store = useMedicationCheckupStore();

    /**
     * Whether the step shown is over.
     */
    const over = computed(() => store.displayedStep?.status === 'completed');

    /**
     * The step to move on to, once the one shown is over and the course
     * declares one after it.
     */
    const next = computed(() => over.value ? store.nextStep : null);

    const label = computed(() => {
        if (next.value === null) {
            return null;
        }

        return store.declaredStep(next.value.definition_key)?.label ?? null;
    });

    const open = () => {
        if (next.value !== null) {
            store.openStep(next.value.definition_key);
        }
    };

    return {over, next, label, open};
}
